module.exports = __webpack_public_path__ + "img/p1.c9b8f645.png";